function mobileMapFunction(event, id) {
    angular.element(document.getElementById('map-anchor-top-mobile')).scope().ctrl.changeBusinessCard(event,id);
    angular.element(document.getElementById('map-anchor-top-mobile')).scope().$apply();
};

function clickOnMarkerOpenThenScroll(id) {
	angular.element(document.getElementById('map-anchor-top-mobile')).scope().ctrl.showClickedBusinessCardIfHidden(id);
	if(!angular.element(document.getElementById('map-anchor-top-mobile')).scope().$$phase) {
		angular.element(document.getElementById('map-anchor-top-mobile')).scope().$apply();
	}
	//possible timing malfunction when showing new businesscards could happen here 
	smoothScrollToSelector('#'+id);
}

(function (angular) {
    'use strict';
    angular.module("dentist").controller('businesscardsController', businesscardsController);

    function businesscardsController(appointmentService, dentistService, $translate, $filter, $scope, $stateParams, $state, $location, $rootScope, $anchorScroll) {
        
        //jQuery functions initialization
        jQuery(function() {
            initSlickCarousel();
            initSameHeight();
            initItemsZindex();
            initLightbox();
//            initCustomMap();
            initLoadMore();
            initLightboxOpener();
            initFixedBlock();
//            initNavigationSelect();
//            initCustomForms();
//            initFixedMap();
            initializeSmoothScrolling();
        });

        $scope.addCssClassToMapMarkerWithPracticeId = function(cssClass, elementId) {
            angular.element(elementId).addClass(cssClass);
        }
        
        $scope.removeCssClassFromMapMarkerWithPracticeId = function(cssClass, elementId) {
            angular.element(elementId).removeClass(cssClass);
        }

        window.onpopstate = function(event) {
            // support for back button from map: if there is no URL query param for 'view', but we are in mapView, reload the page
            if (!$location.search().view && ctrl.mapView) {
                 window.location.reload();
            }
        };

        //controller initialization
        var ctrl = this;
       
        ctrl.mapDataMarkers = {};
        ctrl.filterDate = new Date();
        ctrl.filterTreatment;
        ctrl.clickedOnMarker;
        ctrl.pageH1;
        ctrl.pageTextParagraph;
        ctrl.updateFilterDate = updateFilterDate;
        ctrl.changeLanguage = changeLanguage;
        ctrl.updateRegionState = updateRegionState;
        ctrl.getPriceDisplayString = getPriceDisplayString;
        ctrl.displayNiceDateString = displayNiceDateString;
        ctrl.isAfterFilterDate = isAfterFilterDate;
        ctrl.sliceTimeSlots = sliceTimeSlots;
        ctrl.updateFilteredTreatments = updateFilteredTreatments;
        ctrl.updateFilteredTimeSlots = updateFilteredTimeSlots;
        ctrl.filterTreatmentTimeSlots = filterTreatmentTimeSlots;
        ctrl.sortOrderPracticeIds = window.sortOrderPracticeIds;
        ctrl.prioritySortOrderPracticeIds = window.prioritySortOrderPracticeIds;
        ctrl.mapPositionPerRegion = window.mapPositionPerRegion;
        ctrl.changeBusinessCard = changeBusinessCard;
        ctrl.isSpecialFakeTimeSlotCase = isSpecialFakeTimeSlotCase;
        ctrl.regionOptions = ['appenzellerland', 'aargau', 'basel', 'bern', 'biel', 'chur', 'luzern', 'nidwalden', 'schaffhausen', 'solothurn', 'st-gallen', 'thun', 'winterthur', 'zug', 'zuerich']; // mostly alphabetically
        ctrl.regionExtensions = { 'zuerich': ['winterthur', 'aargau'],
                             'winterthur': ['zuerich'],
                             'schaffhausen' : ['winterthur'],
                             'zug': ['zuerich'],
                             'luzern': ['nidwalden'],
                             'nidwalden': ['luzern'],
                              'bern': ['thun'],
                              'thun': ['bern'],
                               'appenzellerland': ['st-gallen'],
                               'st-gallen': ['appenzellerland']
                               };
        ctrl.treatmentOptions = ['CHECK_UP_NEW', 'CHECK_UP_HYGIENE', 'DENTAL_HYGIENE', 'EMERGENCY_NEW', 'PAIN', 'TOOTH_BROKEN', 'GUM_PROBLEM', 'FILLING', 'BLEACHING', 'BLEACHING_HOME', 'VENEER', 'WISDOM_TOOTH', 'CONSULT_IMPLANT', 'ROOT', 'CONSULT_BRACE', 'CROWN', 'OTHER','SECOND_OPINION_ORTHODONTICS','CONSULT_ORTHODONTICS'];
        ctrl.treatmentOptionsDividerIndices = [0, 3, 8, 10];
        ctrl.isCurrentFilterTreatmentKoVo = isCurrentFilterTreatmentKoVo;
        ctrl.isLandingPage = true;
        ctrl.mapView = false;
        ctrl.mobileMapSlotsCounter = 2;
        ctrl.changeMobileMapView = changeMobileMapView;
        ctrl.mapClick = mapClick;
        ctrl.currentPracticeMobileMap = -1;
        ctrl.getTimeSlotsOfExternalPractices = getTimeSlotsOfExternalPractices;
        ctrl.clickOnProduct = clickOnProduct;
        ctrl.clickOnTimeslotVariant = clickOnTimeslotVariant;
        ctrl.setTreatmentCallFunctions = setTreatmentCallFunctions;
        ctrl.nameOfTreatmentDropdownSync = nameOfTreatmentDropdownSync;
        ctrl.hideNewDropdown = hideNewDropdown;
        ctrl.orderBySpecialLocationRules = orderBySpecialLocationRules;
        ctrl.highlightBusinesscard = '';
        ctrl.goToProfileMiniBcard = goToProfileMiniBcard;
        ctrl.profileViewGA = profileViewGA;

        ctrl.showClickedBusinessCardIfHidden = showClickedBusinessCardIfHidden;
        ctrl.practicesCount = 7;
        ctrl.practicesCountStep = 5;
        ctrl.showMore = showMore;

        ctrl.sortOptions = [
                {
                    name : 'Vorschlag',
                    getter : function(e) {
                        return ctrl.sortOrderPracticeIds.indexOf(e.id);
                    },
                    getter_2 : function(e) {
                        var filteredTimeSlotsAvailable = (e.filteredTimeSlots !== undefined);
                        var slots;
                        var startTimeAttribute;
                        if (filteredTimeSlotsAvailable) {
                            slots = e.filteredTimeSlots;
                            startTimeAttribute = '$key';
                        } else {
                            slots = e.timeSlots.sort(function (a,b) { return a.startTime.localeCompare(b.startTime); });
                            startTimeAttribute = 'startTime';
                        }
                        return slots.length > 0 ? new Date(slots[0][startTimeAttribute]) : new Date(2999, 12, 31);
                    }
                },
                {
                    name : 'Verfügbarkeit',
                    getter : function(e) {
                        return e.filteredTimeSlots.length > 0 ? new Date(e.filteredTimeSlots[0].$key) : new Date(2999, 12, 31);
                    }
                },
                /*{
                    name : 'Distanz',
                    getter : function(e) {
                        var coords = e.coordinates.split(",");
                        var yDiff = 47.376895 - Number(coords[0]); // coords of Zurich Bahnhofplatz
                        var xDiff = 8.541869 - Number(coords[1]); // coords of Zurich Bahnhofplatz
                        return Math.sqrt((yDiff*yDiff) + (xDiff*xDiff));
                    }
                },*/
                {
                    name : 'Preis',
                    getter : function(e) {
                        if (treatmentHasNoPrice(ctrl.filterTreatment)) {
                            return e.taxpunktwert;
                        }
                        
                        var lowestPrice = 999999;
                        $.each(e.filteredTreatments, function(index, treat) {
                            var price = treat.fixedPriceReduced != null ? treat.fixedPriceReduced : (treat.fixedPrice != null ? treat.fixedPrice : (treat.minPrice != null ? treat.minPrice : treat.maxPrice));
                            if (price < lowestPrice) {
                                lowestPrice = price;
                            }
                        });
                        return lowestPrice;
                    }
                }
//                {
//                    name : 'Taxpunktwert',
//                    getter : 'taxpunktwert'
//                }
        ];
        ctrl.currentSorting = ctrl.sortOptions[0];

        init();

        function init() {
            if (regionIsSupported($stateParams.region)) {
                ctrl.region = $stateParams.region;
            } else {
                ctrl.region = ctrl.regionOptions[0];
            }

            // TODO no special handling necessary anymore, could be integrated directly into ctrl.sortOptions
           	//if (ctrl.region == 'zuerich') {
           	    var availabilityGetter = ctrl.sortOptions[findSortOptionIndex('Verfügbarkeit')].getter;
           		ctrl.sortOptions[ctrl.sortOptions.length] = { name: 'Besuchserlebnis', getter: ['-averageRating', availabilityGetter] };
           	//}
           	
            initializeLandingPageBehaviour($stateParams.landingTexts);
            
        	ctrl.clickedOnMarker = false;

            if ($stateParams.treatment) {
                ctrl.filterTreatment = $stateParams.treatment;
            }
            
            var urlParamIsPresent = true; // !angular.equals($location.search(), {});
            if (urlParamIsPresent) {
                hideNewDropdown();
            } else {
                $(window).click(function() {
                    hideNewDropdown();
                });
            }
            
            if ($stateParams.highlight) {
            	ctrl.highlightBusinesscard = $stateParams.highlight;
            }

            // TODO [dom] replace with REST-call that supports multiple regions
            ctrl.practices = [];
            var allRegions = [ctrl.region].concat(ctrl.regionExtensions[ctrl.region] || []);
            addPracticesForRegion(allRegions, function() {
                initializationByPractices();
                setNumberOfReviews();
            });
        }

        function addPracticesForRegion(regions, practicesInitializer) {
            if (regions.length == 0) {
                practicesInitializer();
            } else {
                dentistService.getAllPracticeBusinessCards(regions[0]).then(function (res) {
                    var result = res.data;

                    result.forEach(function(practice) {
                        practice.filteredTimeSlots = [];
                        practice.filteredTreatments = [];
                    });
                    ctrl.practices.push.apply(ctrl.practices, result);

                    addPracticesForRegion(regions.slice(1), practicesInitializer);
                }, function (error) {
                    // TODO [dom] error handling
                    addPracticesForRegion(regions.slice(1), practicesInitializer);
                    console.log(error);
                });
            }
        }

        function addPracticesForRegions_experimental(regions) {
            ctrl.practices = [];
            regions.forEach(function(region) {
                dentistService.getAllPracticeBusinessCards(region).then(function (res) {
                    var result = res.data;

                    result.forEach(function(practice) {
                        practice.filteredTimeSlots = [];
                        practice.filteredTreatments = [];
                    });
                    ctrl.practices.push.apply(ctrl.practices, result);

                    initializationByPractices(result);
                    setNumberOfReviews();

                }, function (error) {
                    // TODO [dom] error handling
                    console.log(error);
                });
            });
        }

        function profileViewGA(practice) {
        	var dataLayer = window.dataLayer || [];
        	
        	var data = {
        		'ecommerce': {
	          	    'currencyCode': 'CHF',
	          	    'click': {
	          	        'actionField': {'list': 'Bcards list' + (ctrl.currentSorting ? ' - ' + ctrl.currentSorting.name : '')},
	          	        'products': [{
	          	          'name': 'BcardsProfileClick',
	          	          'brand': practice.name
	          	         }]
	          	       }
	          	  }
            };
      	
        	dataLayer.push(data);
        	
        	dataLayer.push({
                'event':'businesscardClick'
            });
        }
        
        function goToProfileMiniBcard() {
        	if(ctrl.clickedOnMarker) {
        		profileViewGA(ctrl.currentPracticeMobileMap);
        	}
        	
        	var index = getFilteredAndOrderedPractices().indexOf(ctrl.currentPracticeMobileMap);
        	
        	var treatment = $filter('orderBy')(ctrl.currentPracticeMobileMap.filteredTreatments, 'noTimeSlotsAvailable')[0];
        	
        	var data = {
                	  'ecommerce': {
                	    'currencyCode': 'CHF',
                	    'click': {
                	        'actionField': {'list': 'Bcards list' + ' mobile-map'},
                	        'products': [{
                	          'name': String(treatment.type),                      // Name or ID is required.
                	          //'id': String(practice.name+treatment.type),
                	          'brand': String(ctrl.currentPracticeMobileMap.name),
                	          'coupon': treatment.fixedPriceReduced ? (treatment.reductionCoupon.description ? treatment.reductionCoupon.description : treatment.reductionCoupon.code) : '',
                	          //'variant': String(variant),
                	          'position': Number(index + 1)
                	         }]
                	       }
                	  }
                	};
        	
        	if (treatment.fixedPrice) {
        		data.ecommerce.click.products[0].price = Number(treatment.fixedPrice); 
        	}
        	
          	var dataLayer = window.dataLayer || [];        	
          	dataLayer.push(data);
          	
          	dataLayer.push({
                'event':'businesscardClick'
            });
          	
          	localStorage.setItem("ecommerceObject", JSON.stringify(data));
        }
        
        function showMore() {
        	ctrl.practicesCount = ctrl.practicesCount+ctrl.practicesCountStep;
        	getProductsImpressions(true);
        }
        
        function initializationByPractices() {
            getTimeSlotsOfExternalPractices(ctrl.practices);
            
            handleSpecialTreatmentCases(ctrl.practices);

            handleSpecialFakeTimeSlotCases(ctrl.practices);
            
            ctrl.updateFilteredTreatments(ctrl.practices);
            ctrl.updateFilteredTimeSlots(ctrl.practices);
            
            /* if (!$stateParams.treatment) {
            	setActiveSortOption('Vorschlag');
            } */
            
            // init Google map
            var mapDataMarkers = buildMapDataMarkers(ctrl.practices, true);
            $('.js-map-fixed').data('markers', mapDataMarkers);
            
            var mapPositionAndZoom = ctrl.mapPositionPerRegion[ctrl.region] || [];
            initCustomDesktopMap(mapPositionAndZoom[0], mapPositionAndZoom[1]);
            initFixedMap();
            
            if (isBot()) {
            	ctrl.practicesCount = ctrl.practices.length;
            }
            
            if($stateParams.scroll) {
            	//TODO find a nice way to scroll to practice
//            	console.log("scrolling..?");
//            	showClickedBusinessCardIfHidden($stateParams.scroll);
//            	
//            	$location.hash($stateParams.scroll);
//            	$anchorScroll();
        	}
        }
        
        function setNumberOfReviews() {
	        for(var i=0; i<ctrl.practices.length; i++) {
           		if(ctrl.practices[i].averageRating >= 0 && ctrl.practices[i].averageRating < 7) {
           			ctrl.practices[i].ratingText = 'Besuchserlebnis';
    			} else if(ctrl.practices[i].averageRating >= 7 && ctrl.practices[i].averageRating < 8) {
    				ctrl.practices[i].ratingText = 'Gut';
    			} else if(ctrl.practices[i].averageRating >= 8 && ctrl.practices[i].averageRating < 8.5) {
    				ctrl.practices[i].ratingText = 'Sehr Gut';
    			} else if(ctrl.practices[i].averageRating >= 8.5 && ctrl.practices[i].averageRating < 9) {
    				ctrl.practices[i].ratingText = 'Fabelhaft';
    			} else if(ctrl.practices[i].averageRating >= 9 && ctrl.practices[i].averageRating < 9.5) {
    				ctrl.practices[i].ratingText = 'Hervorragend';
    			} else if(ctrl.practices[i].averageRating >= 9.5 && ctrl.practices[i].averageRating <= 10) {
    				ctrl.practices[i].ratingText = 'Aussergewöhnlich';
    			}
    			ctrl.practices[i].averageRating = Number($filter('number')(ctrl.practices[i].averageRating, 1));
           	}
        }
        
        function orderBySpecialLocationRules(item) {
        	// TODO see about performance optimization possibility (the practices are filtered two times if the region is not winterthur -> try solving it in html with double filters
        	var order = $filter('orderBy')(ctrl.practices, ctrl.currentSorting.getter).findIndex(function (el) { return el.id == item.id});
            if (ctrl.prioritySortOrderPracticeIds[item.id] != null) {
                order = ctrl.prioritySortOrderPracticeIds[item.id] - 0.1;
            }

            // if having practices from other regions in list, and region not zuerich, then we move the foreign ones down
        	if ((ctrl.region != item.location) && !(ctrl.region == 'zuerich' && item.location == 'winterthur')) {
    			order = order + (ctrl.practices.length * ( ctrl.regionExtensions[ctrl.region].indexOf(item.location)+1 ));
        	}

    		return order;
        }
        
        function initializeLandingPageBehaviour(landingTexts) {
            var replaceRegionPlaceholderWithTranslation = function (text, noTranslate) {
                var region = noTranslate ? ctrl.region : $filter('translate')(ctrl.region);
                return text ? text.replace(/{region}/g, region) : null;
            };
            if (landingTexts) {
                ctrl.isLandingPage = true;
                $rootScope.pageTitle = replaceRegionPlaceholderWithTranslation(landingTexts.title);
                $rootScope.pageDescription = replaceRegionPlaceholderWithTranslation(landingTexts.description);
                $rootScope.canonicalLink = null;
                ctrl.pageH1 = replaceRegionPlaceholderWithTranslation(landingTexts.h1);
                ctrl.pageTextParagraph = replaceRegionPlaceholderWithTranslation(landingTexts.p);
            } else {
                ctrl.isLandingPage = false;

                // TODO [dom] generic title per treatment
                var treatmentTranslation = $filter('translate')(ctrl.filterTreatment);
                if (!treatmentTranslation) {
                    treatmentTranslation = 'Zahnarzt & DH';
                }
                $rootScope.pageTitle = replaceRegionPlaceholderWithTranslation(treatmentTranslation + " in {region} online buchen | Zumedo.ch");

                $rootScope.pageDescription = null;
                $rootScope.canonicalLink = replaceRegionPlaceholderWithTranslation(findCanonicalLinkForCurrentTreatment(), true);
                ctrl.pageH1 = null;
                ctrl.pageTextParagraph = null;
            }
        }
        
        function findCanonicalLinkForCurrentTreatment() {
            if (!ctrl.filterTreatment) {
                return '/zahnarzt/{region}/';
            }

            var page = window.businesscardsLandingPages.find(function(page) { return page.treatment == ctrl.filterTreatment; });
            if (!page) {
                console.log("WARN: businesscardsLandingPage for canonical link not found for treatment: " + ctrl.filterTreatment);
                return null;
            }
            
            return page.isDedicatedLandingPage ? page.path : '/zahnarzt' + page.path; 
        }
        
        function isBot(){
        	var botPattern = "(googlebot\/|Google Page Speed Insights|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
	        var re = new RegExp(botPattern, 'i');
	        return re.test(navigator.userAgent);
        }
        
        function setTreatmentCallFunctions(event){
        	var element = $(event.currentTarget);
        	var treatment = element.attr('data-original');
        	ctrl.filterTreatment = treatment;
        	
        	ctrl.updateFilteredTreatments(ctrl.practices); 
        	ctrl.updateFilteredTimeSlots(ctrl.practices);
        	
        	$('.jcf-select-text').filter(":contains('Behandlung')").text(element.text());
        	ctrl.hideNewDropdown();
        }
        
        function nameOfTreatmentDropdownSync() {
        	var name;
        	if(ctrl.filterTreatment) {
        		name = $filter('translate')(ctrl.filterTreatment);
        	} else {
        		name = "Behandlung wählen:";
        	}
        	$('.jcf-select-text').eq(0).text(name);
        }
        
        function hideNewDropdown() {
        	$('#treatment-popup-dropdown').hide();
        }
        
        function showClickedBusinessCardIfHidden(id) {
        	var	sorted = getFilteredAndOrderedPractices();
        	var index = sorted.findIndex(function (element) {
        			return parseInt(element.id) == parseInt(id); 
        	});

        	if((index != -1) && (index+1) > ctrl.practicesCount - 1) {
    			ctrl.practicesCount = index+2;
    			if(ctrl.practicesCount%ctrl.practicesCountStep != 0) {
    				ctrl.practicesCount = ctrl.practicesCount - ctrl.practicesCount%ctrl.practicesCountStep + ctrl.practicesCountStep;
    			}
    		}
        }

        function getFilteredAndOrderedPractices() {
            var filteredPractices = $filter('filter')(ctrl.practices, ctrl.filterTreatment);
            return $filter('orderBy')(filteredPractices, ctrl.orderBySpecialLocationRules);
        }
        
        // PRODUCTS IMPRESSIONS when clicked on treatment filtering on top of page
        function getProductsImpressions(showMore) {
        	var data = {
          		  'ecommerce': {
          		    //'currencyCode': 'CHF',                       // Local currency is optional.
          		    'impressions': []
          		  }
          		};
        	
        	var treatmentName = ctrl.filterTreatment ? ctrl.filterTreatment : 'ALL';
        	
        	getFilteredAndOrderedPractices().forEach(function(p, i) {
        		if((i < ctrl.practicesCount && !showMore) || (showMore && (i < ctrl.practicesCount) && (i >= (ctrl.practicesCount - ctrl.practicesCountStep)))) { 
        			
        			var treatment = $filter('orderBy')(p.filteredTreatments, 'noTimeSlotsAvailable')[0];
        			
        			data.ecommerce.impressions[i] = 
        			{
        					'name': treatmentName, // Name or ID is required.
        					//'id': String(p.name+ctrl.filterTreatment),
        					'brand': p.name,
        					//'category': treatment.fixedPriceReduced ? (treatment.reductionCoupon.description ? treatment.reductionCoupon.description : '') : '',
        					'variant': treatment.noTimeSlotsAvailable  ? 'unavailable' : null,
        					'list': 'Bcards list' + (ctrl.currentSorting ? ' - ' + ctrl.currentSorting.name : ''),
        					'position': Number(i + 1)
        			}
        		}
            });
        	
        	var dataLayer = window.dataLayer || [];        	
        	dataLayer.push(data);
        	
        	//console.log("product impressions: " + JSON.stringify(data));
        }
        
        // PRODUCT CLICK when clicked on treatment in the bcard
        function clickOnProduct(treatment, practice) {
        	clickDataPush(practice, treatment, true);
        }
        
        function calculateTimeVariant(timeString) {
        	var time = moment(timeString);
        	
        	if (time.isBefore(moment().add(1, 'days'))) {
        		return "24h";
        	} else if(time.isBefore(moment().add(2, 'days'))) {
        		return "24h-48h";
        	} else if(time.isBefore(moment().add(7, 'days'))) {
        		return "2d-1week";
        	} else if(time.isBefore(moment().add(14, 'days'))) {
        		return "1week-2weeks";
        	} else if(time.isBefore(moment().add(1, 'months'))) {
        		return "2weeks-1month";
        	} else if(time.isBefore(moment().add(2, 'months'))) {
        		return "1month-2months";
        	} else if(time.isBefore(moment().add(6, 'months'))) {
        		return "2months-6months";
        	} else if(time.isBefore(moment().add(12, 'months'))) {
        		return "1year";
        	} else {
        		return "over1year";
        	}
        }
        
        // PRODUCT CLICK when clicked on timeslot in the bcard
        function clickOnTimeslotVariant(practice, timeString, treatmentId, isInList) {
            var treatment = practice.filteredTreatments.find(function(treat) { return treat.originalIds.indexOf(treatmentId) >= 0; } );
            
        	var variant = calculateTimeVariant(timeString);
        	
        	clickDataPush(practice, treatment, isInList, variant);
        }
        
        function clickDataPush(practice, treatment, isInList, variant) {
        	var index = getFilteredAndOrderedPractices().indexOf(practice);
        	
        	var data = {
                	  'ecommerce': {
                	    'currencyCode': 'CHF',
                	    'click': {
                	        'actionField': {'list': 'Bcards list' + (ctrl.currentSorting ? ' - ' + ctrl.currentSorting.name : '')},      // Optional list property.
                	        'products': [{
                	          'name': String(treatment.type),                      // Name or ID is required.
                	          //'id': String(practice.name+treatment.type),
                	          'brand': String(practice.name),
                	          'coupon': treatment.fixedPriceReduced ? (treatment.reductionCoupon.description ? treatment.reductionCoupon.description : treatment.reductionCoupon.code) : '',
                	          //'variant': String(variant),
                	          'position': Number(index + 1)
                	         }]
                	       }
                	  }
                	};
        	
        	if (isInList) {
        	    data.ecommerce.click.actionField = {'list': 'Bcards list'  + (ctrl.currentSorting ? ' - ' + ctrl.currentSorting.name : '')};
        	    data.ecommerce.click.products[0].position = Number(index + 1);
        	}
        	
        	if (variant) {
        		data.ecommerce.click.products[0].variant = String(variant);
        	}
        	
        	if (treatment.fixedPrice) {
        		data.ecommerce.click.products[0].price = Number(treatment.fixedPrice); 
        	}
        	
        	var dataLayer = window.dataLayer || [];
        	dataLayer.push(data);
        	
        	localStorage.setItem("ecommerceObject", JSON.stringify(data));
//        	console.log(localStorage.getItem("ecommerceObject"));
        	
        	dataLayer.push({
                'event':'businesscardClick'
            });
        	
        	//console.log("bcard click data: " + JSON.stringify(data));
        }

        function getTimeSlotsOfExternalPractices(practices) {
            practices.forEach(function(practice) {
            	if(practice.useExternalCalendar) {
            		//initiate loading gif
            		practice.isLoading = true;
            		
            		//practice id
            		var data = { practiceId: practice.id };
            		
            		//start and end date
            		var startDate = moment().format("YYYY-MM-DD");
		            var endDate = moment().add(3, 'M').format("YYYY-MM-DD");
            		
            		//practitioners
	                var practitionerIdsTemp = practice.groupedTreatments.reduce(function(total, treatment) {
	                    return total.concat(treatment.practitionerIds);
	                }, []);
	                
	                var uniquePractitionerIds = new Set();
	                
	                practitionerIdsTemp.forEach(function(element) {
	                    uniquePractitionerIds.add(element);
	                });
	                
	                var practitionerIds = Array.from(uniquePractitionerIds);
	                
	                //service call for getting external time slots
	                appointmentService.getAllAppointmentsOfPractitioner(data,practitionerIds, startDate, endDate).then(function (res) {
	                    var result = res.data;
	                    
	                	practice.timeSlots = result;
	                	
	                    updateFilteredTimeSlots([practice]);
	                    
	                    //hide loading gif
	            		practice.isLoading = false;
	                }, function (error) {
	                    // TODO [dom] error handling
	                    console.log("error in businesscards.js when additionally getting external time slots"+error);
	                });
            	}	
            });
        }
        
        function treatmentHasNoPrice(treat) {
            return ['CHECK_UP_NEW', 'CHECK_UP_HYGIENE', 'DENTAL_HYGIENE', 'EMERGENCY_NEW', 'BLEACHING', 'BLEACHING_HOME'].indexOf(treat) === -1;
        }
        
        function isCurrentFilterTreatmentKoVo() {
            return ['CROWN', 'CONSULT_BRACE', 'ROOT', 'CONSULT_IMPLANT', 'WISDOM_TOOTH', 'VENEER', 'OTHER'].indexOf(ctrl.filterTreatment) !== -1;
        }

        function regionIsSupported(region) {
            return ctrl.regionOptions.indexOf(region) !== -1;
        }
        
        function updateRegionState() {
            if ($stateParams.region !== ctrl.region) {
                $state.go("businesscards", {region: ctrl.region, treatment: ctrl.filterTreatment, landingTexts: null});
            }
        }
        
        function updateFilteredTreatments(practices) {
            if (!ctrl.isLandingPage || ($stateParams.landingTexts && ($stateParams.landingTexts.treatment != ctrl.filterTreatment))) {
                initializeLandingPageBehaviour(null);
            }
            
            practices.forEach(function(practice) {
                practice.filteredTreatments = $filter('filter')(practice.groupedTreatments, ctrl.filterTreatment);
                addUpSellingTreatments(practice);
            });
            
            getProductsImpressions(false);
            
            var treatmentName = ctrl.filterTreatment ? ctrl.filterTreatment : '';
            
                dataLayer.push({
                    'event':'VirtualPageview',
                'virtualPageURL': 'https://www.zumedo.ch/zahnarzt/' + ctrl.region + '/suche?treatment=' + treatmentName
                });
        }

        /**
            if filtered for DH or Kontrolle, also show DH&Kontrolle
        */
        function addUpSellingTreatments(practice) {
            if (['DENTAL_HYGIENE', 'CHECK_UP_NEW'].indexOf(ctrl.filterTreatment) >= 0) {
                var checkUpHygiene = practice.groupedTreatments.find(function(treat) { return treat.type == 'CHECK_UP_HYGIENE'; });
                if (checkUpHygiene) {
                    practice.filteredTreatments.push(checkUpHygiene);
                }
            }
        }

        function updateFilteredTreatmentsTimeAvailability(practices) {
            practices.forEach(function(practice) {
                practice.filteredTreatments.forEach(function(treatment) {
                    if (practice.isLoading || practice.filteredTimeSlots.some(function(slot) { return slot.some(function(time) { return time.treatmentIds.indexOf(treatment.originalIds[0]) !== -1; }); })) {
                        treatment.noTimeSlotsAvailable = false;
                    } else {
                        treatment.noTimeSlotsAvailable = true;
                    }
                });
                
                updateMarkerState(practice);
            });
        }
        
        function updateMarkerState(practice) {
            if (isTheMapMarkerGrey(practice)) {
                $scope.addCssClassToMapMarkerWithPracticeId("custom-marker-grey", '#marker-'+practice.id);
                $scope.addCssClassToMapMarkerWithPracticeId("custom-marker-grey", '#marker-mobile-id-'+practice.id);
            } else {
                $scope.removeCssClassFromMapMarkerWithPracticeId("custom-marker-grey", '#marker-'+practice.id);
                $scope.removeCssClassFromMapMarkerWithPracticeId("custom-marker-grey", '#marker-mobile-id-'+practice.id);
            }
        }
        
        function isTheMapMarkerGrey(practice) {
        	return practice.filteredTreatments.length == 0 || practice.filteredTimeSlots.length == 0;
        }
        
        function isSpecialTreatmentCase(practice) {
            return practice.id == 30682; // swiss smile
        }

        function sortTreatmentsNewlyByOptionsOrdering(treatments) {
            return treatments.sort(function (a,b) { return ctrl.treatmentOptions.indexOf(a.type) - ctrl.treatmentOptions.indexOf(b.type); });
        }

        function handleSpecialTreatmentCases(practices) {
            practices.forEach(function(practice) {
                practice.groupedTreatments = sortTreatmentsNewlyByOptionsOrdering(practice.groupedTreatments);
                if (isSpecialTreatmentCase(practice)) {
                    practice.groupedTreatments.forEach(function(treat) {
                        if (treat.originalIds.indexOf(34027) >= 0) { // swiss smile Kontrolle und Dentalhygiene
                            treat.type = treat.type + '_PA';
                        }
                        if (treat.originalIds.indexOf(34026) >= 0) { // swiss smile Dentalhygiene
                            treat.type = treat.type + '_DH';
                        }
                    });
                }
            });
        }
        
        function isSpecialFakeTimeSlotCase(practice) {
            return practice.id == 4006;
        }

        function handleSpecialFakeTimeSlotCases(practices) {
            practices.forEach(function(practice) {
                if (isSpecialFakeTimeSlotCase(practice) && practice.timeSlots.length == 0) {
                    var targetDate = moment().add(3, 'months').date(11).format("YYYY-MM-DD"); // the 11th of the month that is 3 months from now
                    practice.timeSlots.push({
                        "practitionerIds" : [4512, 6055, 4501, 4502, 4503, 4504, 4505, 4506, 4507, 4508, 4509, 4510, 4511],
                        "startTime" : targetDate + "T10:00:00+01:00",
                        "endTime" : targetDate + "T11:00:00+01:00"
                      });
                }
            });
        }
        
        function updateFilteredTimeSlots(practices) {
            practices.forEach(function(practice) {
                var filtered = $filter('filter')(practice.timeSlots, ctrl.filterTreatmentTimeSlots(practice));
                filtered = $filter('map')(filtered, ctrl.sliceTimeSlots(practice));
                filtered = $filter('flatten')(filtered, true);
                filtered = $filter('filter')(filtered, ctrl.isAfterFilterDate);
                filtered = $filter('groupBy')(filtered, 'startTime');
                filtered = $filter('toArray')(filtered, true);
                filtered = $filter('orderBy')(filtered, '$key');
                practice.filteredTimeSlots = filtered;
                
                practice.filteredTimeSlotPagingIndex = 0;
                practice.filteredTimeSlotsDisplayCount = 4;
            });
            
            updateFilteredTreatmentsTimeAvailability(practices);
            
            setActiveSortOption('Verfügbarkeit');
        }

        function findSortOptionIndex(optionName) {
            return ctrl.sortOptions.findIndex(function (element) { return element.name === optionName; });
        }
        
        function setActiveSortOption(optionName) {
            var index = findSortOptionIndex(optionName);
            ctrl.currentSorting = ctrl.sortOptions[index];
            $('#option-link-list-' + index).prop('selected', 'selected');
            $('.jcf-option-opt-level-1').text(ctrl.currentSorting.name);
        }

        function manipulateURLAndSetMapViewParam(paramValue) {
            var url = new URL(window.location);
            if (paramValue) {
                url.searchParams.set('view', paramValue);
                window.history.pushState({}, '', url);
            } else {
                url.searchParams.delete('view');
                window.history.replaceState({}, '', url);
            }
        }
        
        function changeMobileMapView() {
        	ctrl.mapView = !ctrl.mapView;
        	
        	if (ctrl.mapView) {
        	    manipulateURLAndSetMapViewParam('map'); // to support back-button, back to the list

            	document.getElementById("mapswitch").setAttribute("style", "position: fixed; bottom: auto; top: 10px; z-index:99999999999;");
            	document.getElementsByTagName("body")[0].setAttribute("style", "overflow: hidden;");
            	
            	$('#map-anchor-top-mobile').css('position', ''); // unhide
            	
            	$('#map-anchor-bottom').hide();
            	
            	$('#header').hide();
            	
            	/* GOOGLE TRANSLATE UGLY REMOVAL - START */
	            	$("[id=':1.container']").hide();
	                var frame = $("[id=':1.container']");
	            	frame.contents().find("[id=':1.promptSection']").css({display:"none"});
	            	$("div[class='skiptranslate']").css({display:"block", position:"fixed", right:"-1000px"});
            	/* GOOGLE TRANSLATE UGLY REMOVAL - END */
            	
            	initializeMapMobile();
        	} else {
            	manipulateURLAndSetMapViewParam(null); // reset view param to normal list view

            	document.getElementById("mapswitch").setAttribute("style", "position: fixed; bottom: 10px; top: auto;");
            	document.getElementsByTagName("body")[0].setAttribute("style", "overflow: scroll;");
            	
            	$('#map-anchor-top-mobile').css('position', 'absolute'); // hide
            	
            	$('#map-anchor-bottom').show();
            	
            	$('#header').show();
        	}
        	
        	$(window).scroll(); // to address some problem with the Google-Map-initialization
        }
        
        function initializeMapMobile() {
            var mapDataMarkersMobile = buildMapDataMarkers(ctrl.practices, false);
            $('.js-map-mobile').data('markers', mapDataMarkersMobile);
            
            initCustomMobileMap();
        }
        
        function changeLanguage(langKey) {
            $translate.use(langKey);
            localStorage.setItem("lang", langKey);
        }
        
        function displayNiceDateString(dateString) {
        	var dateMoment = moment(dateString);
        	var today = moment();
        	
        	if (today.isSame(dateMoment, 'day')) {
        		return "heute um\n" + $filter('date')(dateString, "HH:mm");
        	} else if (today.add(1, 'days').isSame(dateMoment, 'day')) {
        		return "morgen um\n" + $filter('date')(dateString, "HH:mm");
        	} else {
        		return $filter('date')(dateString, "EEE, d.M. 'um'") + "\n" + $filter('date')(dateString, "HH:mm");
        	}
        }
        
        function getPriceDisplayString(treatment) {
            var priceCalculated = "";
            if (treatment.fixedPrice != null) {
                priceCalculated += $filter('currency')(treatment.fixedPrice);
            }
            else if (treatment.minPrice != null && treatment.maxPrice == null) {
                priceCalculated += $filter('translate')('from') + $filter('currency')(treatment.minPrice);
            }
            else if (treatment.minPrice == null && treatment.maxPrice != null) {
                priceCalculated += $filter('translate')('to') + $filter('currency')(treatment.maxPrice);
            }
            else if (treatment.minPrice != null && treatment.maxPrice != null) {
                priceCalculated += treatment.currency + ' ' + treatment.minPrice + ' - ' + treatment.maxPrice;
            }
            return priceCalculated;
        }
        
        function mapClick() {
        	ctrl.clickedOnMarker = false;
        	$scope.removeCssClassFromMapMarkerWithPracticeId('custom-marker-active', '#marker-mobile-id-' + ctrl.currentPracticeMobileMap.id);
        }
        
        function changeBusinessCard(event, id) {
	        	var currentPractice;
	        	
	        	$scope.removeCssClassFromMapMarkerWithPracticeId('custom-marker-active', '#marker-mobile-id-' + ctrl.currentPracticeMobileMap.id);
	        	
	        	event.stopPropagation();
	        	
	        	for (var i = 0; i < ctrl.practices.length; i++) {
	        		currentPractice = ctrl.practices[i];
	        		if(currentPractice.id == parseInt(id)) {
	        			ctrl.currentPracticeMobileMap = currentPractice;
	        		}
	        	}
	        	ctrl.clickedOnMarker = true;
	        	$scope.addCssClassToMapMarkerWithPracticeId('custom-marker-active', '#marker-mobile-id-' + id);
        }
        
        function buildMapDataMarkers(practices, isDesktop) {
            var mapDataMarkers = [];
            var practicesLength = practices.length;
            var currentPractice;
            var currentMarker;
            var currentCoordinates;
            var additionalClass;
            var funcStringInjection = "";
            var markerId = "";
            
            for (var i = 0; i < practicesLength; i++) {
                currentPractice = practices[i];
                currentMarker = { "location": [] };
                currentCoordinates = currentPractice.coordinates.split(",");
                
                currentMarker.location.push(Number(currentCoordinates[0]));
                currentMarker.location.push(Number(currentCoordinates[1]));
                currentMarker.extraClass = "";
                additionalClass = !isTheMapMarkerGrey(currentPractice) || currentPractice.useExternalCalendar ? "" : " custom-marker-grey";
               
                if(isDesktop) {
                	funcStringInjection="onclick=clickOnMarkerOpenThenScroll('";
                	markerId = "marker-";
                } else {
                	funcStringInjection="onclick=mobileMapFunction(event,'";
                	markerId = "marker-mobile-id-";
                }
                currentMarker.popupHTML = "<a href='javascript:void(0);'><span title='" + currentPractice.name + "' id='" + markerId + currentPractice.id + "' class='map-marker " + additionalClass + "' " + funcStringInjection + currentPractice.id+"') ><span class='icon-marker'></span></span></a>";
                mapDataMarkers.push(currentMarker);
            }
            return mapDataMarkers;
        }
        
        function filterTreatmentTimeSlots (practice) {
            var matchingTreatments = $filter('filter')(practice.groupedTreatments, ctrl.filterTreatment);

            var practitionerIds = matchingTreatments.reduce(function(total, treatment) {
                return total.concat(treatment.practitionerIds);
            }, []);
            var uniquePractitionerIds = new Set();
            practitionerIds.forEach(function(element) {
                uniquePractitionerIds.add(element);
            });

            return function (timeSlot, index, array) {
                return timeSlot.practitionerIds.some(function(id) {
                    return uniquePractitionerIds.has(id);
                });
            };
        }

        // TODO move values into new, dedicated fields on the practice
        ctrl.earliestBookingTimes = {
            '200052': 48, // practice "Ort Hirzel"
            '200051': 48, // practice "Ort Bülach"
            '30675': 20 // practice "Diener"
        };
        function getEarliestBookingTime(practice) {
            var minimumHoursBetweenNowAndBookableAppointment = ctrl.earliestBookingTimes[practice.id] ?
                                                                  ctrl.earliestBookingTimes[practice.id] : 2;
            return moment().add(minimumHoursBetweenNowAndBookableAppointment, 'hours');
        }

        function sliceTimeSlots (practice) {
            var duration = 120; //max treatment
            var earliestBookingTime = getEarliestBookingTime(practice);

            return function (timeSlot) {
                var treatmentIds = [];
                practice.filteredTreatments.forEach(function(element) {
                    if (element.practitionerIds.some(function(id) { return timeSlot.practitionerIds.indexOf(id) !== -1; })) {
                        treatmentIds.push(element.originalIds[0]);
                        if(element.duration < duration) {
                        	duration = element.duration;
                        }
                    }
                });

                var startMoment = moment(timeSlot.startTime);
                var endMoment = moment(timeSlot.endTime);

                var slices = [];
                while (startMoment.clone().add(duration, 'm').isSameOrBefore(endMoment)) {
                	if (startMoment.isSameOrAfter(earliestBookingTime)) {
                        slices.push({ practitionerIds: timeSlot.practitionerIds, treatmentIds: treatmentIds, startTime: startMoment.toDate().toISOString() });
                	}
                    startMoment.add(duration, 'm');
                }
                return slices;
            };
        }
        
        function updateFilterDate(filterDateString) {
            var now = moment();
            var filterDateMoment = filterDateString ? moment(filterDateString, 'DD.MM.YYYY') : now;
            var isToday = now.isSame(filterDateMoment, 'day');
            ctrl.filterDate = isToday ? now.toDate() : filterDateMoment.toDate(); // if it is today, we want to keep the time (i.e. hours and minutes)
            ctrl.updateFilteredTimeSlots(ctrl.practices);
            return isToday ? null : ctrl.filterDate;
        }

        function isAfterFilterDate(timeSlot) {
            return new Date(timeSlot.startTime) > ctrl.filterDate;
        }
        
      
    }

    businesscardsController.$inject = ['appointmentService','dentistService', '$translate', '$filter', '$scope', '$stateParams', '$state', '$location', '$rootScope', '$anchorScroll'];

})(window.angular);
